/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-19 22:34:59
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 00:29:34
 * @FilePath: /wemeet-web-activity/src/components/CouponModal/hooks/useInit.ts
 * @Description: 初始化的一些hooks
 */
import { useCallback, useMemo } from 'react';
import buyerCoupon from "../../Coupon/modal/buyer-coupon";
const useInit = (canUseCouponList, unUseCouponList, close) => {
  const couponList = useMemo(() => canUseCouponList.concat(unUseCouponList), [canUseCouponList, unUseCouponList]);
  // 选择不同门票
  const onChange = useCallback(coupon => {
    const checked = buyerCoupon.toggleSelectedCoupon(coupon);
    checked && buyerCoupon.setFlag(true);
  }, []);

  // 是否可点
  // const canSave = useMemo(() => couponList.findIndex(item => item.checked), [couponList]);

  // 更新选中的优惠券
  const changeSelectCoupon = useCallback(() => {
    const selectOne = couponList.find(item => item.checked);
    // 如果一个都没有的话，就不选中优惠券
    if (selectOne) {
      buyerCoupon.setFlag(false);
      buyerCoupon.updateSelectCoupon({
        ...selectOne,
        checked: false
      });
    } else {
      buyerCoupon.updateSelectCoupon();
      buyerCoupon.setFlag(true);
    }
    close?.();
  }, [couponList]);

  // 点击关闭时候，重新设置下列表为当前选中的
  const closeAndReSet = useCallback(() => {
    close?.();
    if (buyerCoupon.coupon) {
      buyerCoupon.setFlag(false);
      buyerCoupon.updateSelectCoupon({
        ...buyerCoupon.coupon,
        checked: false
      });
    } else {
      buyerCoupon.updateSelectCoupon();
      buyerCoupon.setFlag(true);
    }
  }, [couponList, buyerCoupon.coupon]);
  return {
    onChange,
    // canSave,
    changeSelectCoupon,
    couponList,
    closeAndReSet
  };
};
export default useInit;